import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "../../constants/routes";
import { useAuth } from "../../hooks/useAuth";
import LoadingSpinner from "./LoadingSpinner";

interface AuthMiddlewareProps {
  children: ReactNode;
  requireAuth?: boolean;
}

export const AuthMiddleware = ({
  children,
  requireAuth = false,
}: AuthMiddlewareProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (requireAuth && !isAuthenticated) {
    // Redirect to home instead of login, don't use replace to allow back navigation
    return <Navigate to={ROUTES.HOME} state={{ from: location }} />;
  }

  if (
    isAuthenticated &&
    [ROUTES.LOGIN, ROUTES.SIGN_UP].includes(location.pathname as any)
  ) {
    const redirectTo = location.state?.from || ROUTES.OVERVIEW;

    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
